let pageBody = document.getElementsByTagName("body")[0];
let headerMain = document.getElementsByClassName("header--main")[0];
let headerWrapper = document.getElementsByClassName("header-wrapper")[0];
let interstitial = document.getElementById("interstitial");
let headerWrapperPosition = headerWrapper.getBoundingClientRect().top;
let articleHeader = document.getElementsByClassName(
  "b-article-header-content"
)[0];
let featuredImage = document.getElementsByClassName("post-thumbnail")[0];
let headerAd = document.getElementById("header");
let headerAdWrapper = document.getElementsByClassName("header-ad")[0];
let contentWrapper = document.getElementById("content");
let firstPostTeaser = document.getElementsByClassName("o-post-teaser")[0];
let searchModal = document.getElementsByClassName("b-search-popup")[0];
let footer = document.getElementById("colophon");
let postThumb = document.getElementsByClassName("post-thumbnail")[0];
let mobileMenuTranslate = "100%";
let pageYScroll = 0;
let footerLimiter = 0;

let headerLimiter = 400;

if (header_offset_scroll) {
  headerLimiter = header_offset_scroll;
}

let isMobile = window.outerWidth <= 480;

// OS Detector
let osVersion = navigator.appVersion;
if (osVersion.indexOf("Windows") != -1) {
  pageBody.classList.add("os-windows");
}

// Back to top
let backToTop = document.querySelectorAll(".c-back-to-top")[0];

backToTop.addEventListener("click", () => {
  document.body.scrollTop = 0;
  window.scrollTo({ top: 0, behavior: "smooth" });
});

// Search
let searchTrigger = document.querySelectorAll(".search-trigger");
let searchPopup = document.querySelectorAll(".b-search-popup")[0];
let searchPopupClose = document.querySelectorAll(".b-search-popup-close")[0];

searchTrigger.forEach((item) => {
  item.addEventListener("click", function () {
    searchPopup.classList.add("active");

    if (window.pageYOffset > headerLimiter) {
      searchModal.style.transform =
        "translateY(" + headerAdWrapper.offsetHeight + "px)";
    } else {
      searchModal.style.transform = "translateY(0)";
    }

    document.getElementById("search-form-1").focus();
  });
});

searchPopupClose.addEventListener("click", function () {
  searchPopup.classList.remove("active");
});

document
  .getElementsByClassName("b-search-popup")[0]
  .addEventListener("click", function (e) {
    if (
      !document
        .getElementsByClassName("b-search-popup-top")[0]
        .contains(e.target)
    ) {
      searchPopup.classList.remove("active");
    }
  });

// Header
document.addEventListener("scroll", function (e) {
  if (
    pageBody.classList.contains("error404") ||
    pageBody.classList.contains("search-no-results") ||
    pageBody.classList.contains("primary-navigation-open")
  )
    return;

  let interstitialHeight = interstitial.offsetHeight;

  contentWrapper.style.paddingTop = headerWrapper.offsetHeight + "px";

  if (isMobile) {
    if (window.pageYOffset > interstitialHeight) {
      headerWrapper.classList.add("be-sticky");
    } else if (window.pageYOffset <= interstitialHeight) {
      headerWrapper.classList.remove("be-sticky");
      contentWrapper.style.paddingTop = "0px";
    }

    if (window.pageYOffset > headerLimiter) {
      headerWrapper.style.transform =
        "translateY(-" + headerAdWrapper.offsetHeight + "px)";
    } else {
      headerWrapper.style.transform = "translateY(0)";
    }
  } else {
    if (window.pageYOffset > interstitialHeight) {
      headerWrapper.classList.add("be-sticky");
      headerWrapper.style.marginTop = "-" + headerAdWrapper.offsetHeight + "px";
      contentWrapper.style.marginTop =
        "-" + headerAdWrapper.offsetHeight + "px";
      contentWrapper.style.transition = "margin-top 0.8s linear";
      headerWrapper.style.transition = "margin-top 0.8s linear";
    } else {
      headerWrapper.classList.remove("be-sticky");
      contentWrapper.style.paddingTop = "0px";
      headerWrapper.style.marginTop = "0";
      contentWrapper.style.marginTop = "0";
    }
  }

  if (pageBody.classList.contains("primary-navigation-open")) {
    mobileMenuTranslate = 0;
  } else {
    mobileMenuTranslate = "100%";
  }
  if (isMobile) {
    if (window.pageYOffset > headerLimiter) {
      headerWrapper.classList.add("hide-header-ad");
      backToTop.classList.add("show");

      if (searchModal.classList.contains("active")) {
        searchModal.style.transform =
          "translateY(" + headerAdWrapper.offsetHeight + "px)";
      }

      if (window.innerWidth < 768) {
        headerMain.style.transform =
          "translateX(" +
          mobileMenuTranslate +
          ") translateY(" +
          headerAdWrapper.offsetHeight +
          "px)";
      }
    } else if (window.pageYOffset < headerLimiter) {
      headerWrapper.classList.remove("hide-header-ad");

      if (searchModal.classList.contains("active")) {
        searchModal.style.transform = "translateY(0)";
      }

      if (window.innerWidth < 768) {
        headerMain.style.transform =
          "translateX(" + mobileMenuTranslate + ") translateY(0)";
      }

      backToTop.classList.remove("show");
    }
  }

  footerLimiter = document.body.offsetHeight * 0.7;

  if (window.pageYOffset >= footerLimiter) {
    backToTop.classList.add("bottom");
  } else {
    backToTop.classList.remove("bottom");
  }
});

var mutationObserver = new MutationObserver(function (mutations) {
  mutations.forEach(function (mutation) {
    if (mutation.attributeName == "data-load-complete") {
      if (document.querySelectorAll(".dfp-skin__content")[0]) {
        headerAdWrapper.style.display = "none";
      }

      mutationObserver.disconnect();
    }
  });
});

mutationObserver.observe(document.getElementById("interstitial"), {
  attributes: true,
  subtree: true,
});

document
  .querySelector(".navigation-trigger.open")
  .addEventListener("click", function () {
    document
      .getElementsByTagName("body")[0]
      .classList.add("primary-navigation-open");

    pageYScroll = window.pageYOffset;
    pageBody.style.position = "fixed";

    if (pageYScroll > headerLimiter) {
      headerMain.style.transform =
        "translateX(0) translateY(" + headerAdWrapper.offsetHeight + "px)";
    } else if (pageYScroll < headerLimiter || pageYScroll == 0) {
      headerMain.style.transform = "translateX(0) translateY(0)";
    }
  });

document
  .querySelector(".navigation-trigger.close")
  .addEventListener("click", function () {
    document
      .getElementsByTagName("body")[0]
      .classList.remove("primary-navigation-open");

    pageBody.style.position = "";
    window.scrollTo(0, pageYScroll);
    document.getElementsByClassName("c-navigation")[0].scrollTop = 0;

    if (window.pageYOffset > headerLimiter) {
      headerMain.style.transform =
        "translateX(100%) translateY(" + headerAdWrapper.offsetHeight + "px)";
    } else if (window.pageYOffset < headerLimiter || window.pageYOffset == 0) {
      headerMain.style.transform = "translateX(100%) translateY(0)";
    }
  });

function ResetHeader() {
  if (window.innerWidth > 1023) {
    document
      .getElementsByTagName("body")[0]
      .classList.remove("primary-navigation-open");

    pageBody.style.position = "";
    window.scrollTo(0, pageYScroll);
    document.getElementsByClassName("c-navigation")[0].scrollTop = 0;

    if (window.pageYOffset > headerLimiter) {
      headerMain.style.transform =
        "translateX(100%) translateY(" + headerAdWrapper.offsetHeight + "px)";
    } else if (window.pageYOffset < headerLimiter || window.pageYOffset == 0) {
      headerMain.style.transform = "translateX(100%) translateY(0)";
    }
  }
}

window.onresize = ResetHeader;
